import { useState, useCallback, useRef, useEffect, useMemo } from "react";
import TreeNode from "./TreeNode";
import { Card, CardBody, Button } from "reactstrap";
import { FiPlus } from "react-icons/fi";
import { FaTree } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  createPrgramServiceMapping,
  getAllServices,
} from "../../../../../../store/slices/servicesSlice";
import { getAllSubServices } from "../../../../../../store/slices/subServicesSlice";
import { getCategories } from "../../../../../../store/slices/categories";
import { getAllPrograms } from "../../../../../../store/slices/programsSlice";
import { getSubCategories } from "../../../../../../store/slices/subCategorySlice";
import { CustomSelect } from "./components/CustomSelect";
import {
  returnParentUniqueKey,
  ticketTypeSelectOptions,
  typeSelectOptions,
} from "./utils";

const ServiceTree = () => {
  const dispatch = useDispatch();
  const [programListing, setProgramListing] = useState([]);
  const programDetails = useSelector((state) => state.programs.programDetail);
  const _allServices = useSelector((state) => state.services.allServices);
  const allServices = useMemo(
    () => (Array.isArray(_allServices) ? _allServices : []).map((subService) => ({
      label: subService?.name,
      value: subService.slug_name,
    })),
    [_allServices],
  );
  const _allSubServices = useSelector(
    (state) => state.subServices.allSubServices,
  );
  const allSubServices = useMemo(
    () => (Array.isArray(_allSubServices) ? _allSubServices : []).map((subService) => ({
      label: subService?.name,
      value: subService.slug_name,
    })),
    [_allSubServices],
  );

  const [editName, setEditName] = useState("");

  const [editType, setEditType] = useState("grouped");
  const [ticketType, setTicketType] = useState(
    ticketTypeSelectOptions.map((opt) => opt.value),
  );

  const [allCategories, setCategories] = useState([]);
  const [allSubCategories, setAllSubcategories] = useState([]);

  const createProgramServiceMappingData = async () => {
    let payload = {
      plan_slug: programDetails.slug_name,
      type: programDetails?.type ?? "grouped",
      service_slug: [{ service_slug: editName, type: editType }],
      ticketType,
    };
    await dispatch(createPrgramServiceMapping(payload));

    getAllProgramsData();
  };
  const handleAddRoot = () => {
    if (editName && editType) {
      createProgramServiceMappingData();
    } else {
      alert("Service Name and Service Type is Required");
    }
  };
  const fetchAllSubCategory = async () => {
    let data = await dispatch(getSubCategories());
    const payload = data?.payload;
    const subCategoriesArray = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.subCategories)
        ? payload.subCategories
        : [];
    setAllSubcategories(
      subCategoriesArray.map((item) => {
        return { label: item.name, value: item.slug_name };
      }) || [],
    );
  };

  const fetchAllServices = () => {
    dispatch(getAllServices());
  };
  const fetchAllSubServices = () => {
    dispatch(getAllSubServices());
  };

  const fetchAllCategories = async () => {
    let data = await dispatch(getCategories());
    const payload = data?.payload;
    const categoriesArray = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.categories)
        ? payload.categories
        : [];

    setCategories(
      categoriesArray.map((x) => ({
        label: x.name,
        value: x.slug_name,
      })),
    );
  };

  const getAllProgramsData = useCallback(async () => {
    let payload = {
      getServiceData: true,
      getSubServiceData: true,
      plan_slug: programDetails.slug_name,
      getFilteredData: true,
      getBySlugName: true,
    };
    let data = await dispatch(getAllPrograms(payload));
    if (data.payload) {
      setProgramListing(data.payload[0]);
    }
  }, [dispatch, programDetails.slug_name]);

  useEffect(() => {
    getAllProgramsData();
    fetchAllSubServices();
    fetchAllServices();
    fetchAllCategories();
    fetchAllSubCategory();
  }, []);

  return (
    <div style={{ margin: "0 auto" }}>
      <div
        className="d-flex align-items-center justify-content-between mb-4"
        style={{ flexWrap: "wrap", gap: "1.5rem" }}
      >
        <div className="d-flex align-items-center gap-3">
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: "0.5rem",
              backgroundColor: "rgba(220, 53, 69, 0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <FaTree size={24} color="#dc3545" />
          </div>
          <div>
            <h1 className="h5 mb-0 fw-bold" style={{ color: "#1e2a3a" }}>
              Program Mapping
            </h1>
          </div>
        </div>
        <div
          className="d-flex gap-2 align-items-center"
          style={{
            backgroundColor: "#f8f9fa",
            padding: "0.75rem 1rem",
            borderRadius: "0.5rem",
            border: "1px solid #e9ecef",
            minWidth: "fit-content",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <label
              style={{
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#495057",
                whiteSpace: "nowrap",
              }}
            >
              Service:
            </label>
            <CustomSelect
              value={editName}
              options={allServices}
              onChange={(v) => setEditName(v)}
              placeholder="Select"
              style={{ width: "150px" }}
            />
          </div>
          <div
            style={{ width: "1px", height: "24px", backgroundColor: "#dee2e6" }}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <label
              style={{
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#495057",
                whiteSpace: "nowrap",
              }}
            >
              Type:
            </label>
            <CustomSelect
              value={editType}
              options={typeSelectOptions}
              onChange={(v) => setEditType(v)}
              placeholder="Select"
              style={{ width: "120px" }}
            />
          </div>
          <div
            style={{ width: "1px", height: "24px", backgroundColor: "#dee2e6" }}
          />
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <label
              style={{
                fontSize: "0.875rem",
                fontWeight: 500,
                color: "#495057",
                whiteSpace: "nowrap",
              }}
            >
              Ticket:
            </label>
            <CustomSelect
              value={ticketType}
              options={ticketTypeSelectOptions}
              onChange={(v) => setTicketType(v)}
              placeholder="Select"
              style={{ width: "160px" }}
              isMulti
            />
          </div>
        </div>
        <Button
          color="danger"
          size="sm"
          onClick={handleAddRoot}
          className="d-flex align-items-center gap-1"
          style={{
            fontWeight: 500,
            padding: "0.5rem 1rem",
            whiteSpace: "nowrap",
            boxShadow: "0 2px 4px rgba(220, 53, 69, 0.15)",
          }}
        >
          <FiPlus size={16} />
          Add Service
        </Button>
      </div>

      {/* Tree */}
      <Card className="shadow-sm border">
        <CardBody className="p-1">
          {programListing?.serrvices?.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <FaTree size={40} style={{ opacity: 0.4 }} className="mb-3" />
              <p className="small mb-0">
                No services yet. Add one to get started.
              </p>
            </div>
          ) : (
            <div>
              {programListing?.services?.length > 0 &&
                programListing?.services?.map((node, index) => (
                  <TreeNode
                    key={`${returnParentUniqueKey(node, programListing?.services?.length)}${index}`}
                    node={node}
                    parent={programDetails}
                    previousParent={null}
                    depth={0}
                    allCategories={allCategories}
                    allServices={allServices}
                    allSubServices={allSubServices}
                    allSubCategories={allSubCategories}
                    getAllProgramsData={getAllProgramsData}
                  />
                ))}
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default ServiceTree;
